import "./Files.css";

import { useState, useRef, useEffect } from "react";
import { getUploadFileUrl } from "../../consts";
// import { FileUpload } from "../../axios_with_token";
import { UploadFile, randomUUID } from "../../axios_with_token";

export default function Files({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {required: 1})

    // [important] this set the init value. before widget is load, the form value is set using rcd. 
    const valToFiles = val=>{
        let files = [];
        try{
            files=JSON.parse(val||"[]")
        }catch(err){
            console.log(err, val);
            files = [];
        }
        return files;
    };
    const [files, setFiles] = useState(valToFiles(form.getValues()[fldName]));

    const refData = useRef({
        urlCache: {}
    });

    const uuid=randomUUID();
    const setVal = newValFiles=>{
        const newVal = JSON.stringify(newValFiles);
        form.setValue(fldName, newVal);
        setFiles(newValFiles);        
    }
    const refFile = useRef();

    const handleDelFile = evt=>{
        // imgs.splice(1,1);
        const idx = parseInt(evt.target.getAttribute('idx'));
        files.splice(idx, 1);
        setVal([...files]);
    }

    const addFile = file=>{
        return new Promise((res,rej)=>{
            let reader = new FileReader();
            reader.onerror=function(err){
                rej(err);
            };
            reader.onload = function () {
                res({
                    url: reader.result,
                    name: file.name
                });
            };
            reader.readAsDataURL(file);
        })
    };

    const handleFileChange = evt=>{
        Promise.all(
            Array.prototype.map.call(evt.target.files, addFile)
        ).then(newFiles=>{
            evt.target.value = '';
            const newValFiles = [...files, ...newFiles];
            setVal(newValFiles);
        });
        // .then(newFiles=>{
        //     evt.target.value = '';

        //     for(let i in newFiles){
        //         let uuid = `formCache-${randomUUID()}`;
        //         // formCache[uuid] = {
        //         //     url: newFiles[i].url,
        //         //     fileName: newFiles[i].name
        //         // };
        //         newFiles[i].url = uuid;
        //     }

        //     const newValFiles = [...files, ...newFiles];
        //     setVal(newValFiles);
        // });
    }

    // const handleAddFile = evt=>{
    //     if(opts.allowMultiple){
    //         refFile.current.setAttribute('multiple', 'multiple');
    //     }else{
    //         refFile.current.removeAttribute('multiple');
    //     }

    //     setTimeout(function(){
    //         refFile.current.click();
    //     },200);
    // }

    return <div className="accordion input-files" id={"accordion-"+uuid}>
        {/* <span>{uuid}</span> */}
        <input className="form-control" type="hidden" {...rest} />
        {/* <input 
            type="file" 
            // accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" 
            ref={refFile}
            onChange={handleFileChange}
            style={{"display": "none"}}
        /> */}

        <div className="accordion-item">
            <div className="accordion-header" id={"heading-settings-"+uuid}>
                <div className="m-0 accordion-button my-0 py-1">
                    {/* <button className="btn hover-overlay py-1 images-btn-new" type="button"
                        title="click to select file or drag image on this button."
                        onClick={handleAddFile}
                    >+</button> */}
                    <UploadFile
                        btnClass="btn hover-overlay py-1 images-btn-new"
                        onUploaded={newFiles=>{
                            const newValFiles = [...files, ...newFiles.map(newFile=>({
                                url: newFile.fileUrl,
                                name:  newFile.fileName
                            }))];
                            setVal(newValFiles);
                        }}
                        allowMultiple={true}
                    ></UploadFile>

                    <button className="btn py-1 images-settings-toggle collapsed" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-settings-"+uuid}
                    >
                        settings
                    </button>

                    <button className="btn py-1 images-settings-toggle" type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#collapse-images-"+uuid}
                    >
                        files <span className="pull-right">( {files.length} )</span>
                    </button>

                    
                </div>
            </div>

            <div id={"collapse-settings-"+uuid}
                className="accordion-collapse collapse show"
                aria-labelledby={"heading-settings-"+uuid}
                data-bs-parent={"#accordion-"+uuid}
            >
                <div className="accordion-body border-bottom">

                    <div className="row">
                    </div>

                </div>
            </div>

            <div id={"collapse-images-"+uuid}
                className="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent={"#accordion-"+uuid}
            >
                <div className="accordion-body border-bottom image-list">
                    <ol className="container" style={{marginLeft: "0"}}>
                        {/* <h1>{files.length}</h1> */}
                        {files.map((fileDef, idx)=>{
                            return <li key={idx} className="row m-0 p-0" title={ fileDef.name || "file "+(idx+1) }>
                                {/* <img src={fileDef.url} className="card-img-top" /> */}
                                    {/* <button type="button" className="btn-close" aria-label="Close"></button> */}
                                <div className="card-body conatiner m-0 p-0" style={{
                                    "backgroundImage":`url("${fileDef.url}")`,
                                    "backgroundRepeat": "no-repeat",
                                    "backgroundSize": "cover",
                                    "backgroundPosition": "center",
                                }}>
                                    {/* <a href={refData.current.urlCache[fileDef.url]?refData.current.urlCache[fileDef.url].url:getUploadFileUrl(fileDef.url)}>{fileDef.name||fileDef.url}</a> */}
                                    <a href={fileDef.url&&(fileDef.url.startsWith('data:')?fileDef.url:getUploadFileUrl(fileDef.url))}
                                        target="__blank__"
                                    >{fileDef.name||fileDef.url}</a>
                                    
                                    <button type="button" className="btn btn-close float-end m-0 p-0" aria-label="Close"
                                        idx={idx}
                                        onClick={handleDelFile}
                                    ></button>
                                    {/* <h5 className="card-title">Card title</h5> */}
                                    {/* <p className="card-text">img-{idx+1}</p> */}
                                    {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
                                </div>
                            </li>;
                        })}
                    </ol>
                </div>
            </div>            
        </div>
    </div>;
}
